import pagesIndividualApprovalTasksEn from './approval-tasks/default';
import pagesIndividualApprovalsEn from './approvals/default';
import pagesIndividualClockingCorrectionEn from './clocking-correction/default';
import pagesIndividualContractEn from './contract';
import pagesIndividualHomeEn from './home/default';
import pagesIndividualLookupResourcesEn from './lookup-resources/default';
import pagesIndividualMyProfileEn from './my-profile/default';
import pagesIndividualOperationPackageEn from './operation-package/default';
import pagesIndividualOperationTasksEn from './operation-tasks/default';
import pagesIndividualRequestTasksEn from './request-tasks/default';
import pagesIndividualRequestEn from './request/default';
import pagesIndividualSideNavEn from './side-nav/default';
import pagesIndividualTasksEn from './tasks/default';
export default {
  approvalTasks: pagesIndividualApprovalTasksEn,
  approvals: pagesIndividualApprovalsEn,
  clockingCorrection: pagesIndividualClockingCorrectionEn,
  contract: pagesIndividualContractEn,
  home: pagesIndividualHomeEn,
  lookupResources: pagesIndividualLookupResourcesEn,
  myProfile: pagesIndividualMyProfileEn,
  operationPackage: pagesIndividualOperationPackageEn,
  operationTasks: pagesIndividualOperationTasksEn,
  request: pagesIndividualRequestEn,
  requestTasks: pagesIndividualRequestTasksEn,
  sideNav: pagesIndividualSideNavEn,
  tasks: pagesIndividualTasksEn
};